import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../../api'

const baseURL = `${baseAPI}/marketplace`

export const getMarketplaceBalanceKey = 'getMarketplaceBalance'

export const getMarketplaceBalance = (queries?: GetMarketplaceBalanceRequest) =>
  axios.get<GetMarketplaceBalanceResponse>(`${baseURL}/balance`, {
    params: queries
  })
